import MuiDivider, { DividerProps } from '@mui/material/Divider';
import { dividerSx } from './Divider.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const Divider = (props: DividerProps) => {
  return <MuiDivider {...props} sx={[dividerSx, props.sx] as SxProps<Theme>} />;
};
